export default "__VITE_ASSET__n5SZO4dn__"